<template>
  <div class="pagination row flex-center">
    <div class="flex-1"></div>
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="paginationConfig.current"
      :page-sizes="pagesizeOptions"
      :page-size="paginationConfig.size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="paginationConfig.total"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  inheritAttrs: true,
  name: "pagination",
  props: {
    // 每页条数，由父组件传入；未传时使用 default
    size: {
      type: Number,
      default: 10,
    },
    pagesizeOptions: {
      type: Array,
      default: () => [10, 20, 50, 100],
    },
  },
  data() {
    return {
      paginationConfig: {
        current: 1,
        // 初始条数与 props.size 一致（父组件可传 :size="20" 等）
        size: this.size,
        total: 0,
      },
    };
  },
  components: {},
  mounted() {},
  methods: {
    handleSizeChange(e) {
      let that = this;
      this.paginationConfig.current = 1;
      this.paginationConfig.total = 0;
      this.paginationConfig.size = e;

      that.$emit("sizeChange", {
        info: that.paginationConfig,
        e: e,
      });
    },
    handleCurrentChange(e) {
      let that = this;
      that.paginationConfig.current = e;
      that.$emit("currentChange", {
        info: that.paginationConfig,
        e: e,
      });
    },
    clearPage() {
      let that = this;
      return new Promise((resolve, reject) => {
        that.paginationConfig.current = 1;
        that.paginationConfig.total = 0;
        resolve();
      });
    },
    setTotal(num) {
      this.paginationConfig.total = num;
    },
  },
};
</script>

<style></style>
